import styled from 'styled-components'

interface INavigationSectionStyledProps {}

export const NavigationSectionStyled = styled.div<INavigationSectionStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  margin-top: ${(props) => props.theme.typography.pxToRem(24)};
`
